import React from 'react';
import { StyleSheet, Platform, View } from 'react-native';

type Props = {
  attributes: Record<string, string>;
  height: number;
  style: Record<string, any>;
};

type BorderStyle = 'solid' | 'dotted' | 'dashed';

const Line: React.FC<Props> = (props) => {
  const { height } = props;
  const styles = createStyle(props);

  return (
    <View style={{ height: height, overflow: 'hidden' }}>
      <View style={styles.container}></View>
    </View>
  );
};

const createStyle = (props: Record<string, any>) => {
  const { attributes, height, style } = props;
  const { backgroundColor, borderStyle } = style ?? {};

  return StyleSheet.create({
    container: {
      width: attributes.borderStyle !== 'none' ? style?.width : 0,
      height,
      ...(attributes.borderStyle !== 'none'
        ? {
            borderStyle:
              (borderStyle as BorderStyle) ??
              (attributes.borderStyle as BorderStyle),
            borderColor: backgroundColor ?? attributes.backgroundColor,
          }
        : { borderWidth: 0 }),
      ...Platform.select({
        ios: {
          borderWidth: height / 2,
          borderRadius: 1,
          marginTop: -height / 2,
          marginLeft: -height / 2,
          marginRight: -height / 2,
        },
        android: {
          borderWidth: height / 2,
          borderRadius: 1,
          marginTop: -height / 2,
          marginLeft: -height / 2,
          marginRight: -height / 2,
        },
        default: {
          borderTopWidth: height,
          // other platforms, web for example
        },
      }),
    },
  });
};

export default Line;
